import React, { useState } from "react";
import InputBox from "../../Component/UI/InputBox";
import AddButton from "../../Component/UI/AddButton";
import ReactSelect from "../../Component/UI/ReactSelect"
import { MdCheckCircle, MdOutlineCircle } from "react-icons/md";
import { LuUsers } from "react-icons/lu";
import { FiUpload } from "react-icons/fi";

export default function UpdateUserModal({ onClose, updateForm, handleUpdateChange, onSubmit }) {

  const [hovered, setHovered] = useState(null);

  const cards = [
    {
      id: "manual",
      title: "Add user manually",
      desc: "Select users to create new team.",
      icon: LuUsers,
    },
    {
      id: "upload",
      title: "Add users with file upload",
      desc: "Upload a file to add many teams.",
      icon: FiUpload,
    },
  ];

  const fields = [
    { label: "User Name", name: "name" },
    { label: "Email Address", name: "email" },
    { label: "Mobile No.", name: "mobile" },
  ];


  const [form, setForm] = React.useState({
    name: "",
    email: "",
    mobile: ""
  });



  const colourOptions = [
    { value: 'ocean', label: 'Ocean', color: '#00B8D9' },
    { value: 'blue', label: 'Blue', color: '#0052CC' },
    { value: 'purple', label: 'Purple', color: '#5243AA' },
    { value: 'red', label: 'Red', color: '#FF5630' },
  ];


  return (

    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40" />

      {/* Modal Container */}
      <div className="relative bg-white w-full max-w-4xl rounded-2xl p-8 z-10">
        {/* Title */}
        <h2 className="text-xl font-semibold mb-4">Update User</h2>


        {/* Form */}
        <div className="space-y-4">
          {fields.map(({ label, name }) => (
            <InputBox
              key={name}
              label={label}
              name={name}
              value={updateForm[name]}
              onChange={handleUpdateChange}
            />
          ))}
          {/* <div>
            <label className="text-sm font-medium">User Role</label>
            <ReactSelect
              name="role"
              value={form.role}
              options={colourOptions}
              onChange={handleChange}
              placeholder="Select role"
            />

          </div> */}
        </div>

        <div className="flex justify-end gap-4 mt-8">
          <button onClick={() => onClose()} className="px-6 py-2 border rounded-md"  >Cancel</button>
          <AddButton title="Update" className="bgcolor text-white px-6" onClick={() => onSubmit(updateForm)} />
        </div>

        {/* Second model */}
        {/* <div className="space-y-4">
          <div>
            <h3 className="text-lg font-semibold">Users import file</h3>
            <p className="text-sm text-gray-500">
              Download the users import file template to upload your team.{" "}
              <span className="text-[#009688] cursor-pointer font-medium">
                Download .csv example
              </span>
            </p>
          </div>
          <div className="flex items-center justify-between border rounded-lg px-4 py-3">
            <div className="flex items-center gap-3">
              <FiFileText className="w-6 h-6 text-gray-500" />
              <div>
                <p className="font-medium text-sm">Users.csv</p>
                <p className="text-xs text-gray-500">17.1 kbs</p>
              </div>
            </div>
            <FiX className="w-5 h-5 text-gray-500 cursor-pointer" />
          </div>
          <div className="border-2 border-dashed border-gray-200 rounded-xl p-10 bg-gradient-to-b from-[#E0F2F180] to-white flex flex-col items-center justify-center text-center">
            <div className="w-16 h-16 rounded-full bg-[#E0F2F180] flex items-center justify-center mb-4">
              <FiUpload className="w-7 h-7 text-[#009688]" />
            </div>
            <p className="font-medium text-sm">Upload .csv file</p>
            <p className="text-xs text-gray-500 mt-1">
              Drag & drop your file here or{" "}
              <span className="text-[#009688] cursor-pointer font-medium">
                click to browse
              </span>
            </p>
          </div>
        </div> */}
      </div>

    </div>
  );
}
